import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    homeScrollY: 0, // 滚动位置记录
    listScrollY: 0,
    bookScrollY: 0,
  },
  getters: {
    homeScrollY: state => state.homeScrollY,
    bookScrollY: state => state.bookScrollY,
    listScrollY: state => state.listScrollY,
  },
  mutations: {
    changelistScrollY(state, listScrollY) { // 保存页面离开时的位置 接口列表页面
      state.listScrollY = listScrollY
    },
    changeHomeScrollY(state, homeScrollY) { // 首页
      state.homeScrollY = homeScrollY;
    },
    changeBookScrollY(state, bookScrollY) { // 保存页面离开时的位置 教材页面
      state.bookScrollY = bookScrollY
    },
  },
  actions: {},
});
